<template>
   <div class="my-2 flex flex-col gap-5" :class="{ 'mt-0': !top }">
      <div v-if="showLine" class="bg-grey/20 h-[1px] w-full rounded-full" />
      <div
         v-if="title || description || icon"
         class="mx-auto flex w-fit items-center justify-center gap-3"
         :class="{ __clickable: !!icon }"
         @click="$emit('action')"
      >
         <Icon
            v-if="iconBefore"
            class="size-5"
            :class="{
               'text-grey': color === 'grey',
               'text-gold': color === 'gold',
               'text-primary': color === 'primary',
            }"
            :name="iconBefore"
         />
         <div
            v-if="title || description"
            class="flex flex-col gap-1"
            :class="{
               'text-grey': color === 'grey',
               'text-gold': color === 'gold',
               'text-primary': color === 'primary',
            }"
         >
            <p v-if="title" class="p-l text-center">{{ title }}</p>
            <p v-if="description" class="p-m mx-auto opacity-70">{{ description }}</p>
         </div>
         <Icon
            v-if="icon"
            class="size-5"
            :class="{
               'text-grey': color === 'grey',
               'text-gold': color === 'gold',
               'text-primary': color === 'primary',
            }"
            :name="icon"
         />
      </div>
   </div>
</template>

<script lang="ts" setup>
type Emit = {
   action: []
}

type Props = {
   showLine?: boolean
   title?: string
   description?: string
   top?: boolean
   icon?: string
   iconBefore?: string
   color?: 'gold' | 'grey' | 'primary'
}

const props = withDefaults(defineProps<Props>(), {
   showLine: true,
   top: true,
   color: 'grey',
})

const emit = defineEmits<Emit>()
</script>
